function getMessages({ accountId }, apiClient) {
  const route = apiClient.route `/libraries/${':librarySubdomain'}/messages`;
  return apiClient.get(route, { query: { accountId } });
}

export default {
  getMessages
};



// WEBPACK FOOTER //
// ./app/api/MessagesApi.js